export default __webpack_public_path__ + "static/media/header-profile.66434b95.jpg";